import React, { useEffect } from 'react';
import styled from 'styled-components';
import { ADSENSE_CONFIG } from '../../config/adsense';

const AdContainer = styled.div`
    margin: 2rem 0;
    text-align: center;
    min-height: ${props => props.height || '250px'};
    display: flex;
    align-items: center;
    justify-content: center;
    
    @media (max-width: ${props => props.theme.queries.mobile}) {
        margin: 1.5rem 0;
        min-height: ${props => props.mobileHeight || '200px'};
    }
`;

const AdSenseAd = ({ 
    adSlot, 
    adFormat = "auto", 
    adLayout = null,
    fullWidthResponsive = true,
    height = "250px",
    mobileHeight = "200px",
    style = {}
}) => {
    useEffect(() => {
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (e) {
            console.error('AdSense error:', e);
        }
    }, []);

    const adProps = {
        className: "adsbygoogle",
        style: {
            display: 'block',
            ...style
        },
        "data-ad-client": ADSENSE_CONFIG.publisherId,
        "data-ad-slot": adSlot,
        "data-ad-format": adFormat,
        "data-full-width-responsive": fullWidthResponsive
    };

    // Agregar data-ad-layout solo si se proporciona
    if (adLayout) {
        adProps["data-ad-layout"] = adLayout;
    }

    return (
        <AdContainer height={height} mobileHeight={mobileHeight}>
            <ins {...adProps} />
        </AdContainer>
    );
};

export default AdSenseAd;